import $ from "jquery"
import "jquery-match-height";

$('.js-human-item-matchheight').matchHeight();
$('.js-services-item-matchheight').matchHeight();
$('.js-box-experience-matchheight').matchHeight();
$('.js-gain-matchheight').matchHeight();

$(window).on('resize', function(){
    setTimeout(function(){
        $('.js-human-item-matchheight').matchHeight();
        $('.js-services-item-matchheight').matchHeight();
        $('.js-box-experience-matchheight').matchHeight();
        $('.js-gain-matchheight').matchHeight();
    }, 500);
});